import { Component } from '@angular/core';
import { StorageService } from './storage.service';
import { Router, NavigationEnd } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
import { TramApiService } from './tram-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Чижик';
  menu: MenuItem[];
  isAuthenticated: boolean;
  isPopState = false;
  isMenuOpened = false;
  toasterconfig: ToasterConfig;

  constructor(
    private api: TramApiService,    
    private storage: StorageService,
    private router: Router,
    private locationStrategy: LocationStrategy) {

    this.menu = [
      {
        title: 'О проекте',
        link: '/about',
        isClickable: true,
        isActive: false,
        nestedMenu: [
          {
            isActive: false,
            title: 'Концепция',
            link: '/concept'
          },
          {
            isActive: false,
            title: 'Участники',
            link: '/participants'
          },
          {
            isActive: false,
            title: 'Социальная ответственность',
            link: '/responsibility'
          },
          {
            isActive: false,
            title: 'Вакансии',
            link: '/vacancy'
          }
        ]
      },
      {
        title: 'Информация',
        isActive: false,
        nestedMenu: [
          {
            isActive: false,
            title: 'Маршруты',
            link: '/routes'
          },
          {
            isActive: false,
            title: 'Расписание',
            link: '/schedule'
          },
          {
            isActive: false,
            title: 'Правила перевозки',
            link: '/rules'
          },
          {
            isActive: false,
            title: 'Способы оплаты',
            link: '/payment-info'
          },
          {
            isActive: false,
            title: 'Политика конфиденциальности',
            link: '/policy'
          },
          // {
          //   isActive: false,
          //   title: 'Вопрос-ответ',
          //   link: '/faq'
          // }
        ]
      },
      {
        isActive: false,
        title: 'Сервисы',
        nestedMenu: [
          {
            isActive: false,
            title: 'Оплата проезда',
            link: '/pay'
          },
          {
            isActive: false,
            title: 'Интерактивная карта',
            link: '/interactive-map'
          }
        ]
      },
      {
        isActive: false,
        title: 'Новости и акции',
        link: '/news',
        isClickable: true,
      },
      {
        isActive: false,
        title: 'Отзывы',
        link: '/feed',
        isClickable: true,
      }
    ].map(i => this.wrapMenuItem(i));

    const accountMenuItem = this.wrapMenuItem({
        isActive: false,
        title: 'Личный кабинет',
        link: '/account',
        iconClass: 'fa fa-user-circle-o',
        isClickable: true
    });
    this.menu.push(accountMenuItem);

    storage.isSensitiveDataExist.subscribe(isAuthenticated => {
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated) {
            this.api.getCurrentUser().then(user => {
                accountMenuItem.badge = user.isAdmin ? 'А' : user.isModerator ? 'М' : null;
                accountMenuItem.subtitle = user.isAdmin ? 'Админ' : user.isModerator ? 'Модератор' : null;
            });
        } else {
            accountMenuItem.badge = null;
            accountMenuItem.subtitle = null;
        }
    });

    //#region RESET SCROLL TO TOP
    this.locationStrategy.onPopState(() => {
      this.isPopState = true;
    });

    this.router.events.subscribe(event => {
      // Scroll to top if accessing a page, not via browser history stack
      if (event instanceof NavigationEnd && !this.isPopState) {
        window.scrollTo(0, 0);
        this.isPopState = false;
      }

      // Ensures that isPopState is reset
      if (event instanceof NavigationEnd) {
        this.isPopState = false;
      }
    });
    //#endregion
    this.toasterconfig = new ToasterConfig({
      showCloseButton: true,
      limit: 5,
      timeout: 3000
    });
  }

  activate(item: MenuItem) {
    if (item instanceof ParentMenuItem) {
      if (!item.isClickable || item.isActive) {
        return;
      }
    }

    this.isMenuOpened = false;

    this.resetActiveMenuItem();
    item.isActive = !item.isActive;

    const nestedItem = item as NestedMenuItem;
    if (nestedItem.action) {
      nestedItem.action();
    }
  }

  resetActiveMenuItem() {
    this.menu.some((i: ParentMenuItem) => {
      const isActive = i.isParentActive;
      if (isActive) {
        i.isActive = false;
        if (!i.nestedMenu) {
          return;
        }
        i.nestedMenu.some(ni => {
          if (ni.isActive) {
            ni.isActive = false;
            return true;
          }
          return false;
        });
      }

      return isActive;
    });
  }

  logout() {
    if (this.isAuthenticated && this.storage.isSensitiveDataExist.getValue()) {
      this.storage.clear();
    }
  }

  private wrapMenuItem(item): ParentMenuItem {
    const i = new ParentMenuItem();
    i.title = item.title;
    i.subtitle = item.subtitle;
    i.badge = item.badge;
    i.isActive = item.isActive;
    i.isClickable = item.isClickable;
    i.isDisabled = item.isDisabled;
    i.isHidden = item.isHidden;
    i.link = item.link;
    i.iconClass = item.iconClass;
    if (item.nestedMenu) {
      i.nestedMenu = item.nestedMenu.map(ni => this.wrapNestedMenuItem(ni));
    }

    return i;
  }

  private wrapNestedMenuItem(item): NestedMenuItem {
    const i = new NestedMenuItem();
    i.title = item.title;
    i.isActive = item.isActive;
    i.isDisabled = item.isDisabled;
    i.isHidden = item.isHidden;
    i.link = item.link;
    i.action = item.action;

    return i;
  }
}

class MenuItem {
  title: string;
  link: string;
  isHidden: boolean;
  isDisabled: boolean;
  isActive: boolean;
}

class ParentMenuItem extends MenuItem {
  iconClass: string;
  isClickable: boolean;
  badge: string;
  subtitle: string;
  nestedMenu: NestedMenuItem[];
  get isParentActive() {
    return this.isActive || (this.nestedMenu && this.nestedMenu.some(i => i.isActive));
  }
}

class NestedMenuItem extends MenuItem {
  action: () => void;
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/app.component.ts